<template>
  <component :is="currentFooter" :key="currentFooter" />
</template>

<script>
import ComputerFooter from '@/components/computer/FooterComponent.vue'
import Tablet768Footer from '@/components/tablet768/FooterComponent.vue'

export default {
  name: 'FooterRwd',
  components: {
    ComputerFooter,
    Tablet768Footer
  },
  data() {
    return {
      currentFooter: null,
      mediaQueryComp: window.matchMedia('(min-width: 1023px)'),
      mediaQueryOther: window.matchMedia('(max-width: 1023px)')
    }
  },
  created() {
    this.handleResize()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      if (this.mediaQueryOther.matches) {
        this.currentFooter = Tablet768Footer
      }
      else if (this.mediaQueryComp.matches) {
        this.currentFooter = ComputerFooter
      }
    }
  }
}
</script>